<template>
  <div>
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <div v-if="showClientsGraphic">
      <apexchart type="line" height="300" :options="clientsRegisterOptions" :series="clientsRegisterData"></apexchart>
    </div>
  </div>
</template>
<script>

import apexchart from 'vue-apexcharts'
import DialogLoading from '@/components/loading/DialogLoading'
import message from '@/utils/message'
import api from '@/services/api'

export default {
  components: {
    apexchart: apexchart,
    DialogLoading
  },

  data: () => ({
    showClientsGraphic: false,
    loading: true,
    loadingMessage: 'Carregando',
    clientsRegisterData: [
      {
        name: 'Clientes por dia',
        type: 'column',
        data: []
      },
      {
        name: 'Acumulado Clientes',
        type: 'line',
        data: []
      }
    ],
    clientsRegisterOptions: {
      chart: {
        type: 'line'
      },
      stroke: {
        width: [0, 4]
      },
      title: {
        text: 'Cadastros de Clientes dia/acumulado'
      },
      dataLabels: {
        enabled: true
      },
      labels: ['']
    }
  }),
  created () {
    this.getRecordsInfos()
  },

  methods: {
    async getRecordsInfos () {
      try {
        this.loading = true
        const { data } = await api.get('/records-clients-infos')

        data.forEach((info, index) => {
          this.clientsRegisterOptions.labels[index] = info.date
          this.clientsRegisterData[0].data.push(info.total)
          this.clientsRegisterData[1].data.push(info.acum)
        })

        this.showClientsGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de clientes')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboards/RecordsClients.vue